import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { map, Observable } from 'rxjs';
import { ReceiptsRequestModel } from '../../helpers/objects/request/receipts/receipts-request-model';
import { ReceiptsResponseModel } from '../../helpers/objects/response/receipts/receipts-response-model';
import { ReceiptDetailModel } from '../../helpers/objects/dto/receipt-detail/receipt-detail-model';
import { Router, UrlSerializer } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FeaturesEnum } from '@fh-client-interaction-frontends/fh-sales-portal-enums';

@Injectable({
  providedIn: 'root'
})
export class ReceiptsService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) protected appConfigImport: EnvironmentModel,
    private serializer: UrlSerializer,
    private translateService: TranslateService,
    private router: Router
  ) {
    this.appConfig = appConfigImport;
  }

  get(filter: ReceiptsRequestModel): Observable<ReceiptsResponseModel> {
    if (filter.pageSize == undefined) {
      filter.pageSize = 5;
    }

    const httpParams: HttpParams = new HttpParams({
      fromObject: filter as any
    });

    return this.http
      .get<any>(this.appConfig.api + 'receipts/' + this.appConfig.apiPartnershipId, {
        params: httpParams
      })
      .pipe(map((response) => response.body as ReceiptsResponseModel));
  }
  getDetails(id: string): Observable<ReceiptDetailModel> {
    return this.http
      .get<any>(this.appConfig.api + 'receipts/' + this.appConfig.apiPartnershipId + '/' + id)
      .pipe(map((response) => response.body.receiptDetail as ReceiptDetailModel));
  }

  download(filter: ReceiptsRequestModel): string {
    const extraParams = {
      pageSize: 10000,
      page: 1,
      Authorization: sessionStorage.getItem('token'),
      location: this.translateService.currentLang
    };
    const params = { ...filter, ...extraParams };
    const query = this.router.createUrlTree([], { queryParams: params });
    return this.appConfig.api + 'receipts-worksheet/' + this.appConfig.apiPartnershipId + '?' + (this.serializer.serialize(query).split('?')[1] || '');
  }
}
